<template>
    <div class="col-sm-12">
        <div class="form-group">
            <span class="filter-icon"><i class="fa fa-font"></i></span>

            <label for="searchByColumn">
                <select id="searchByColumn"
                        class="form-control input-sm"
                        v-model="searchableColumn">
                    <option value disabled>- Choose a column -</option>
                    <option v-for="column in columns"
                            :key="column.idx" :value="column.prop">{{$t(`messages.${column.title}`)}}
                    </option>
                </select>
            </label>

            <input type="text"
                   id="searchByColumnVal"
                   class="form-control input-sm"
                   v-model="searchVal"
                   style="transform: translateY(1px)">
        </div>
    </div>
</template>

<script>
  export default {
    props: {
      /**
       * An array of objects having following structure:
       * {title: <colTitle>, apiTitle:<apiColTitle>, idx: <columnIndex>}
       */
      columns: {
        type: Array,
        required: true
      },
      loading: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        searchableColumn: null,
        searchVal: null
      }
    },
    computed: {
      /**
       * Query parameter for AJAX call
       * @return {{}}
       */
      q () {
        if (!this.searchableColumn || !this.searchVal) {
          return {}
        }

        const column = this.columns.find(column => {
          return column.prop === this.searchableColumn
        })

        if (!column) {
          throw Error(`Invalid column definitions: Searchable column: ${this.searchableColumn}. Columns: ${JSON.stringify(this.columns)}`)
        }

        return {
          [column.apiTitle]: this.searchVal
        }
      }
    },
    methods: {
      getQuery () {
        return this.q
      },
      reset () {
        this.searchableColumn = null
        this.searchVal = null
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/app/components/datatables/SearchFilter.vue